export default defineNuxtPlugin({
  name: 'authRoot:plugin',
  parallel: true,
  setup() {
    const { support } = useAuth()

    support.loadAuthConfig()
  },
})
